module.exports = __webpack_public_path__ + "static/media/SamuraiFraserMenu.414fc464.pdf";